import { nafColor } from '@nafcore/theme';
import React from 'react';
import styled from '@emotion/styled';
import { colors } from '@naf-simba/theme';
import { Season } from '@appTypes/ElPrixContextData';
import { HighChartComponent } from '@components/bilguide/chart/HighChartComponent';
import { Legend } from '../../Testshowcase/Legend';
import { RangeData } from './ElevationChart.utils';
import { PointOfInterest } from './RouteCharts';
import { useElevationChartOptions } from './useElevationChartOptions';
import { elevationChartStyles } from './ElevationChart.styles';

interface Props {
  altitudes: number[];
  pointsOfInterest: PointOfInterest[];
  className?: string;
  rangeData?: RangeData;
  season?: Season;
  testDate?: string;
  display?: 'route' | 'range';
}

const Plot: React.FC<Props> = ({
  altitudes,
  pointsOfInterest,
  rangeData,
  className,
  display = 'route',
  season,
  testDate,
}) => {
  const options = useElevationChartOptions({
    altitudes,
    pointsOfInterest,
    rangeData,
    display,
    season,
    testDate,
  });

  return (
    <>
      {display === 'range' && rangeData && (
        <Legend
          items={[
            {
              label: (
                <>
                  WLTP: <b>{rangeData.stated} km</b>
                </>
              ),
              key: 'stated',
              color1: nafColor.signature.black,
              shape: 'square',
            },
            {
              label: (
                <>
                  Målt: <b>{rangeData.measured} km</b>
                </>
              ),
              key: 'measured',
              color1: season === 'winter' ? nafColor.information.information : nafColor.information.successDark,
              shape: 'line',
            },
            {
              key: 'diff',
              label: (
                <>
                  Avvik: <b>{Math.round(Math.abs(rangeData.measured - rangeData.stated))} km</b>
                </>
              ),
              color1: rangeData.measured > rangeData.stated ? colors.secondary[100] : nafColor.information.errorDark,
              shape: 'line',
            },
          ]}
        />
      )}
      <HighChartComponent containerProps={{ className }} options={options} />
    </>
  );
};

export const ElevationChart = styled(Plot)<{ season?: Season }>`
  ${({ season }) => elevationChartStyles(season)}
`;
